import { render, staticRenderFns } from "./ReportSearchWordsTable.vue?vue&type=template&id=936edec4"
import script from "./ReportSearchWordsTable.vue?vue&type=script&lang=js"
export * from "./ReportSearchWordsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports